import LeadModuleConfiguration from "./LeadModuleConfiguration";
import {LeadsControllerName, LeadServiceName} from "../utils/names/serviceNames";
import {LeadsController} from "./controller/root/LeadsController";
import {LeadService} from "./service/LeadService";
import {LeadsTableComponent} from "./controller/table/LeadsTableComponent";

LeadModuleConfiguration.createNewModule()
    .controller(LeadsControllerName, LeadsController.instance)
    .component('leadsTable', LeadsTableComponent.instance)
    .service(LeadServiceName, LeadService.instance);